import Vue from 'vue'
import router from './router'
import App from './App.vue'

import './global-components'

import VueCesium from 'vue-cesium'
import lang from 'vue-cesium/lang/en-us'

Vue.use(VueCesium,{
  lang:lang,
  cesiumPath: '/Cesium/Cesium.js'
})


import VueWindowSize from 'vue-window-size'
Vue.use(VueWindowSize)

import L from 'leaflet'
Vue.use(L)

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
